import Session from "./Session";

class User {
    constructor() {
        this.id = "";                 // Guid ID 
        this.iD_EMPRESA = "";         // Guid ID_EMPRESA
        this.iD_INTRANET = 0;         // int ID_INTRANET
        this.dS_NOME = "";           // string DS_NOME 
        this.senha = "";             // string SENHA
        this.dS_CNPJ = "";          // string DS_CNPJ
        this.email = "";            // string EMAIL
        this.booL_MASTER = false;   // bool BOOL_MASTER
        this.role = {};             // Roles ROLE
        this.dS_PANEL_SERIAL = "";  // string DS_PANEL_SERIAL
    }

    static fromSession(session) {
        const user = new User();
        user.id = session.id;
        user.iD_EMPRESA = session.companyId;
        user.iD_INTRANET = session.intranetId;
        user.dS_NOME = session.name;
        user.senha = session.password;
        user.dS_CNPJ = session.cnpj;
        user.email = session.email;
        user.booL_MASTER = session.master;
        user.role = session.roles;
        user.dS_PANEL_SERIAL = session.serial;
        return user;
    }

    static fromApi(apiUser) {
        const user = new User();
        user.id = apiUser.id;
        user.iD_EMPRESA = apiUser.iD_EMPRESA || apiUser.companyId;
        user.iD_INTRANET = apiUser.iD_INTRANET || apiUser.intranetId;
        user.dS_NOME = apiUser.dS_NOME || apiUser.name;
        user.senha = apiUser.senha || apiUser.password;
        user.dS_CNPJ = apiUser.dS_CNPJ || apiUser.cnpj;
        // Prioriza email, mas aceita dS_EMAIL
        user.email = apiUser.email || apiUser.dS_EMAIL || "";
        user.booL_MASTER = apiUser.booL_MASTER ?? apiUser.master ?? false;
        user.role = apiUser.role || apiUser.roles || {};
        user.dS_PANEL_SERIAL = apiUser.dS_PANEL_SERIAL || apiUser.serial;
        return user;
    }

    toSession() {
        return new Session(
            this.id,
            this.iD_EMPRESA,
            this.iD_INTRANET, 
            this.booL_MASTER,
            this.dS_NOME,
            this.email,
            this.senha,
            this.dS_CNPJ,
            this.dS_PANEL_SERIAL,
            this.role,
            {}
        );
    }
}

export default User;